var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationCard = function SvgLocationCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261 260",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#074f4f",
    d: "M0 0h261v260H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#daebdb",
    d: "m176.166 86.423-.852.16-28.429 11.02-31.942-11.18-30.026 10.115A2.68 2.68 0 0 0 83 99.094v80.5a2.636 2.636 0 0 0 2.662 2.662l.852-.16 28.429-11.02 31.943 11.18 30.026-10.12a2.68 2.68 0 0 0 1.917-2.555V89.085a2.636 2.636 0 0 0-2.663-2.662m-55.9 13.15 21.3 7.453v62.075l-21.3-7.453Zm-26.618 5.27 15.971-5.377v62.289l-15.971 6.175Zm74.533 58.988-15.972 5.377v-62.235l15.971-6.176Z",
    opacity: 0.31
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8f5f1",
    d: "M130.63 60.248A24.61 24.61 0 0 0 106 84.878c0 18.47 24.63 45.742 24.63 45.742s24.631-27.272 24.631-45.742a24.61 24.61 0 0 0-24.631-24.63m0 33.427a8.8 8.8 0 1 1 8.8-8.8 8.8 8.8 0 0 1-8.8 8.8"
  })));
};
export default SvgLocationCard;